import type { AdminApiClient } from './api-client.ts';
import { AdminSecurityScreen } from './mfa.tsx';
import type { RouteContract } from './routes.ts';
import { AdminSignInScreen, LegacyAdminScreen } from './screens/legacy.tsx';
import { OperationsScreen } from './screens/operations.tsx';
import { PeopleAccessScreen } from './screens/people.tsx';
import { InvitationsScreen } from './screens/invitations.tsx';

export { AdminSignInScreen };

/** Stable public entry point while admin screens live in focused modules. */
export function AdminScreen({
  route,
  client,
  flags,
  onRequestStepUp,
}: {
  readonly route: RouteContract;
  readonly client: AdminApiClient;
  readonly flags?: Readonly<Record<string, boolean>>;
  readonly onRequestStepUp?: () => Promise<void>;
}) {
  if (route.path === '/security')
    return (
      <AdminSecurityScreen
        client={client.mfa}
        onRequestStepUp={onRequestStepUp ?? (async () => undefined)}
      />
    );
  if (route.path === '/users') return <PeopleAccessScreen client={client} />;
  if (route.path === '/invitations') return <InvitationsScreen client={client} />;
  if (['/delivery-operations', '/direct-inventory', '/stores', '/imports'].includes(route.path))
    return <OperationsScreen route={route} client={client} flags={flags} />;
  return <LegacyAdminScreen route={route} client={client} flags={flags} />;
}
